// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeMicroLab = {
  microLabPlatformDataContractInvalid:
    "The Micro Lab platform data contract is invalid for {field_name}: {reason}",
} as const;
